import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import IPEnforcementService from './services/ipEnforcementService'
import FirebaseSecurityService from './services/firebaseSecurityService'
import './i18n/config' // Initialize i18n

// Initialize services
(async () => {
    try {
        // Initialize Firebase Security Service (loads data from Firebase)
        await FirebaseSecurityService.initialize();
        console.log('✅ Firebase Security Service initialized');
        
        // Initialize IP enforcement for client-side blocking
        await IPEnforcementService.initialize();
        console.log('✅ IP Enforcement Service initialized');
    } catch (error) {
        console.error('❌ Failed to initialize services:', error);
    }
})();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
